<template>
  <v-container class="res-complex-page" fluid>
    <div class="res-complex-header">
      <h1 class="res-complex-header__title">Подробная информация</h1>
      <v-btn
        color="primary"
        outlined
        class="res-complex-header__btn text-none"
        dark
        rounded
        @click="goToListResComplex"
      >
        <v-icon left>mdi-home-map-marker</v-icon>
        К списку жилых комплексов
      </v-btn>
    </div>

    <div class="res-complex-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="res-complex-tabs" grow show-arrows="mobile">
        <v-tab
          v-for="tab in visibleTabs"
          :key="tab.route"
          class="res-complex-tab"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTab" class="res-complex-tabs-items">
      <v-tab-item
        v-for="tab in visibleTabs"
        :key="tab.route"
      >
        <v-card class="res-complex-block mt-0" flat outlined>
          <div class="res-complex-tab-content pa-4">
            <component :is="tab.component" />
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DetailResidentComplex from '@/components/residentComplex/components/DetailResidentComplex';
import InformationResidentComplex from '@/components/residentComplex/components/InformationResidentComplex';
import TerritoryMap from '@/components/residentComplex/components/TerritoryMap';
import ListAbonentsResComplex from './components/ListAbonentsResComplex';
import ListCarsNumbersResComplex from './components/ListCarsNumbersResComplex';
import ListTemporaryAbonentsResComplex from './components/ListTemporaryAbonentsResComplex';
import WhitePhoneNumbersResComplex from './components/WhitePhoneNumbersResComplex';
import TravelLog from './components/TravelLog';

export default {
  name: 'BaseResComplex',
  data () {
    return {
      activeTab: 0,
    };
  },
  created () {},
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
    }),
    tabs () {
      return [
        { name: 'Информация', icon: 'mdi-information-outline', component: DetailResidentComplex, route: 'EditResidentialComplexes', show: true },
        { name: 'Информация', icon: 'mdi-information-outline', component: InformationResidentComplex, route: 'InformationResidentComplex', show: true },
        { name: 'Пользователи', icon: 'mdi-account-group-outline', component: ListAbonentsResComplex, route: 'ListAbonentsResComplex', show: true },
        { name: 'Гос номера собственников', icon: 'mdi-car-side', component: ListCarsNumbersResComplex, route: 'ListCarsNumbersResComplex', show: true },
        { name: 'Гостевые пропуска', icon: 'mdi-ticket-outline', component: ListTemporaryAbonentsResComplex, route: 'ListTemporaryAbonentsResComplex', show: true },
        { name: 'Белый список', icon: 'mdi-format-list-checks', component: WhitePhoneNumbersResComplex, route: 'WhitePhoneNumbersResComplex', show: true },
        { name: 'Журнал проезда', icon: 'mdi-clipboard-list-outline', component: TravelLog, route: 'ListTravelLog', show: true },
        { name: 'Территория', icon: 'mdi-map-marker-radius-outline', component: TerritoryMap, route: 'TheMapIndividual', show: true },
      ];
    },
    visibleTabs () {
      return this.tabs.filter(tab => tab.show && this.$canRoute(tab.route));
    },
  },
  methods: {
    ...mapActions({}),
    goToListResComplex () {
      this.$router.push({ name: 'ResidentialComplexes' });
    },
  },
};
</script>

<style lang="scss" scoped>
.res-complex-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.res-complex-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.res-complex-header__btn {
  text-transform: none;
  font-weight: 500;
}

.res-complex-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.res-complex-tabs {
  box-shadow: none;
}

.res-complex-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.res-complex-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.res-complex-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.res-complex-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.res-complex-tabs ::v-deep .v-tabs-bar__prev,
.res-complex-tabs ::v-deep .v-tabs-bar__next {
  flex: 0 0 auto;
  min-width: 44px;
}

.res-complex-tabs-items {
  background: transparent;
}

.res-complex-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.res-complex-tab-content {
  min-height: 200px;
}
</style>
